import { createSlice } from '@reduxjs/toolkit';
const initialState = {
  frontWord: true,
  frontDefinition: false,
  frontPinyin: false,
  frontAudio: true,
  backWord: false,
  backDefinition: true,
  backPinyin: true,
  backAudio: false,
  wordSelection: 0,
  limitSelection: 3,
  memLimitSelection: 0,
  showHintAfterMiss: 3,
  sentenceSelection: 0,
  showOutline: true,
  showCharacter: true
};
const quizSettingsSlice = createSlice({
  name: 'quizSettings',
  initialState,
  reducers: {
    setQuizSettings: (state, action) => {
      return {
        ...state,
        ...action.payload
      };
    },
    toggleFrontWord: state => {
      state.frontWord = !state.frontWord;
    },
    toggleFrontDefinition: state => {
      state.frontDefinition = !state.frontDefinition;
    },
    toggleFrontPinyin: state => {
      state.frontPinyin = !state.frontPinyin;
    },
    toggleFrontAudio: state => {
      state.frontAudio = !state.frontAudio;
    },
    toggleBackWord: state => {
      state.backWord = !state.backWord;
    },
    toggleBackDefinition: state => {
      state.backDefinition = !state.backDefinition;
    },
    toggleBackPinyin: state => {
      state.backPinyin = !state.backPinyin;
    },
    toggleBackAudio: state => {
      state.backAudio = !state.backAudio;
    },
    setWordSelection: (state, action) => {
      state.wordSelection = action.payload;
    },
    setLimitSelection: (state, action) => {
      state.limitSelection = action.payload;
    },
    setMemLimitSelection: (state, action) => {
      state.memLimitSelection = action.payload;
    },
    setShowHintAfterMiss: (state, action) => {
      state.showHintAfterMiss = action.payload;
    },
    setSentenceSelection: (state, action) => {
      state.sentenceSelection = action.payload;
    },
    toggleShowOutline: state => {
      state.showOutline = !state.showOutline;
    },
    toggleShowCharacter: state => {
      state.showCharacter = !state.showCharacter;
    },
    resetQuizSettings: () => initialState
  },
  extraReducers: builder => {
    builder.addCase('settingsSyncSuccess', (state, action) => {
      if (action.payload) {
        const {
          frontWord,
          frontDefinition,
          frontPinyin,
          frontAudio,
          backWord,
          backDefinition,
          backPinyin,
          backAudio,
          wordSelection,
          limitSelection,
          memLimitSelection,
          showHintAfterMiss,
          sentenceSelection,
          showOutline,
          showCharacter
        } = action.payload;
        return {
          ...state,
          ...(frontWord !== undefined && {
            frontWord
          }),
          ...(frontDefinition !== undefined && {
            frontDefinition
          }),
          ...(frontPinyin !== undefined && {
            frontPinyin
          }),
          ...(frontAudio !== undefined && {
            frontAudio
          }),
          ...(backWord !== undefined && {
            backWord
          }),
          ...(backDefinition !== undefined && {
            backDefinition
          }),
          ...(backPinyin !== undefined && {
            backPinyin
          }),
          ...(backAudio !== undefined && {
            backAudio
          }),
          ...(wordSelection !== undefined && {
            wordSelection
          }),
          ...(limitSelection !== undefined && {
            limitSelection
          }),
          ...(memLimitSelection !== undefined && {
            memLimitSelection
          }),
          ...(showHintAfterMiss !== undefined && {
            showHintAfterMiss
          }),
          ...(sentenceSelection !== undefined && {
            sentenceSelection
          }),
          ...(showOutline !== undefined && {
            showOutline
          }),
          ...(showCharacter !== undefined && {
            showCharacter
          })
        };
      }
      return state;
    });
  }
});
export const {
  setQuizSettings,
  toggleFrontWord,
  toggleFrontDefinition,
  toggleFrontPinyin,
  toggleFrontAudio,
  toggleBackWord,
  toggleBackDefinition,
  toggleBackPinyin,
  toggleBackAudio,
  setWordSelection,
  setLimitSelection,
  setMemLimitSelection,
  setShowHintAfterMiss,
  setSentenceSelection,
  toggleShowOutline,
  toggleShowCharacter,
  resetQuizSettings
} = quizSettingsSlice.actions;
export default quizSettingsSlice.reducer;